define([
    'jQuery',
    'underscore',
    'library/fcse-component/component',
    'library/fcse-compatibility/object',
    './flyoutRegistry'],
    function($, _, Component, Object, FlyoutRegistry) {
        /**
         * Flyout Component
         * @constructor
         */
        var Flyout = function (element, options) {
            // Set default options
            var defaultOptions = {
                flyoutClassName: 'flyout',
                hideClassName: 'is-hidden',
                errorClassName: 'error',
                callerElementClass : 'btn',
                closeOnOutsideClick: false,
                closeOnOverlayClick: false,
                submitOnOutsideClick: false
            };

            //Add default options and custom options
            this.addOptions(defaultOptions, options);

            // Call Component
            Component.apply(this, arguments);

            // Myself
            var self = this;

            // Click-handler for Submit-Element
            $('[data-fcse-role="flyout--button-ok"]', this.getElement()).on('click', null, null, function () {
                if (self.hasWidget()){
                    // If validation fails, don't close flyout
                    if (!self.getWidget().isValid()){
                        return;
                    }
                }
                self.accept();
            });

            // Click-Handler for Cancel-Element
            $('[data-fcse-role="flyout--button-cancel"]', this.getElement()).on('click', null, null, function () {
                self.cancel();
            });

            // Register flyout in registry
            this._flyoutRegistry = new FlyoutRegistry();
            this._flyoutRegistry.add(this);
        };

        // Extending Base Component
        Flyout.prototype = $.extend(Object.create(Component.prototype), {
            /**
             * Bind Event-Handler to DOM-Element
             */
            bindEventToCallerElement: function(eventType, callerElement, eventData) {
                var callback = $.proxy(this.bindEventToCallerElementCallback, this);
                Component.prototype.bindEventToCallerElement.call(this, eventType, callerElement, eventData, callback);
            },

            bindEventToCallerElementCallback: function () {
                    var self = this;
                    if (self.getElement().is(':visible')) {
                        self.cancel();
                    } else {
                        self.openFlyout();
                    }
             },

            /**
             * Closer other Flyouts and set its Caller-Elements to initial state
             */
            _closeOther: function() {
                var self = this;
                $.each(this._flyoutRegistry.getAll(), function(idx, flyout){
                    if (flyout !== self){
                        if (flyout.option('submitOnOutsideClick') && !flyout.getElement().hasClass(flyout.option('hideClassName'))) {
                            flyout.accept();
                        } else {
                            flyout.closeFlyout();
                        }
                    }
                });
            },

            /**
             * Open Flyout
             */
            openFlyout: function () {
                var self = this;

                // Close Other Flyouts
                this._closeOther();

                // Show Flyout-Container
                this.getElement().removeClass(this.option('hideClassName'));

                // Add Class to Caller-Element
                this.getCallerElement().addClass(this.option('callerElementOpenClass'));

                // Add handler to close flyout on outside click
                if (this.option('closeOnOutsideClick')){
                    $('html').on('click', $.proxy(this._outsideClickHandler, this));
                }
            },

            /**
             * Handler for handling outside click to close the flyout
             * @param e
             * @private
             */
            _outsideClickHandler: function(e){
                var clickedElement = e.target;

                var self = this;
                if (self.getElement().is(':visible')){
                    var ignoreClick = false;

                    /*
                    This was removed and should be handled by components properly that trigger click events
                    // Avoid clicks that are triggered on HTML element directly, (for example from dropdown)
                    if (clickedElement == $('html')[0]){
                        // ignoreClick = true;
                    }
                    */

                    // Ignore clicks from flyout
                    if (!self.option('closeOnOverlayClick')) {
                        $.each($(self.getElement()), function(idx, elem){
                            if (elem == clickedElement){
                                ignoreClick = true;
                            }
                        });
                    }

                    // Ignore clicks from caller elements
                    $.each($(self.getCallerElement()), function(idx, elem){
                        if (elem == clickedElement){
                            ignoreClick = true;
                        }
                    });

                    $(clickedElement).parentsUntil('html').each(function(index, element){
                        // Ignore clicks from flyout
                        $.each($(self.getElement()), function(idx, elem){
                            if (elem == element){
                                ignoreClick = true;
                            }
                        });

                        // Ignore clicks from caller elements
                        $.each($(self.getCallerElement()), function(idx, elem){
                            if (elem == element){
                                ignoreClick = true;
                            }
                        });
                    });
                    if (!ignoreClick) {
                        if (this.option('submitOnOutsideClick')) {
                            self.accept();
                        } else {
                            self.cancel();
                        }
                    }
                }
            },

            /**
             * Update Caption
             */
            updateCaption: function() {
                if(this.hasCaptionElement() && this.hasWidget()) {
                    var value = this.getWidget().formatValue();
                    if(!_.isNull(value)) {
                        if (this.getWidget().option('captionIsHtml')){
                            this.getCaptionElement().html(this.getWidget().formatValue());
                        } else {
                            this.getCaptionElement().text(this.getWidget().formatValue());
                        }
                    }
                }
            },
            
            /**
             * Close Flyout
             */
            closeFlyout: function () {
                // Update Caption
                this.updateCaption();
                
                // Hide Flyout-Container
                this.getElement().addClass(this.option('hideClassName'));
                
                // Remove Class from Caller-Element
                this.getCallerElement().removeClass(this.option('callerElementOpenClass'));

                // Remove outside click handler
                $('html').off('click', $.proxy(this._outsideClickHandler, this));
            },

            /**
             * Set Widget
             */
            setWidget: function (widget) {
                // Call setWidget from parent
                Component.prototype.setWidget.call(this, widget);
                
                // Bind Accept Event To Widget
                this.bindAcceptEventToWidget($.proxy(this.closeFlyout, this));
                
                // Bind Cancel Event To Widget
                this.bindCancelEventToWidget($.proxy(this.closeFlyout, this));

                // Bind Undo Event To Widget
                this.bindUndoEventToWidget($.proxy(this.closeFlyout, this));

                // Bind Widget change event
                widget.on('change', $.proxy(this._onWidgetChange, this));

                // Bind Widget validationError event
                widget.on('validationError', $.proxy(this._onWidgetValidationError, this));
            },
            
            /**
             * Cancel (Calls Cancel-Method of a Widget)
             * For Flyout cancel calls undo-method, because of the penultimate value is needed
             */
            cancel: function () {
                if(this.hasWidget()) {
                    this._setErrorState(false);
                    this.getWidget().cancel();
                }
            },

            /**
             * Change handler for widget update
             * @param event
             * @private
             */
            _onWidgetChange: function(event){
                this._setErrorState(false);
                this.updateCaption();
            },

            /**
             * Handler for widget ValidationError
             * @param event
             * @private
             */
            _onWidgetValidationError: function(event){
                this._setErrorState(true);
                this.updateCaption();
            },

            /**
             * Helper to set error state to flyout caption
             * @param boolean yes
             * @private
             */
            _setErrorState: function(yes){
                if (this.hasCaptionElement()) {
                    if (yes) {
                        this.getCaptionElement().addClass(this.option('errorClassName'));
                    } else {
                        this.getCaptionElement().removeClass(this.option('errorClassName'));
                    }
                }
            }
        });
        
        return Flyout;
    }
);


//////////////////
// WEBPACK FOOTER
// ./~/fcse-flyout/flyout.js
// module id = 163
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21